// Note: keeping these type here to prevent "Require cycle warning"
// See: https://stackoverflow.com/questions/55664673/require-cycles-are-allowed-but-can-result-in-uninitialized-values-consider-ref

export enum ASSETS_CREATION_STEP {
  ChannelSelection = 'ChannelSelection',
  CreateTargeting = 'CreateTargeting',
  CreateAssetsDesign = 'CreateAssetsDesign',
}
